<h2 mat-dialog-title>Seleccione 
    <span *ngIf="origen=='empresaVentas'">Empresa</span>
    <span *ngIf="origen=='productos'">Producto</span>
</h2>
<mat-dialog-content class="mat-typography">
    <mat-nav-list>
        <span *ngIf="origen=='empresaVentas'">
            <mat-list-item *ngFor="let item of data" (click)="selectedItem(item);">
                {{item.nit}} -- {{item.razonSocial}}
            </mat-list-item>
        </span>
        <span *ngIf="origen=='productos'">
            <mat-list-item *ngFor="let item of data" (click)="selectedItem(item);">
                {{item.idExProducto}} -- {{item.descripcion}}
            </mat-list-item>
        </span>
        <span *ngIf="origen=='tarifas'">
            <mat-list-item *ngFor="let item of data" (click)="selectedItem(item);">
                {{item.valor}} -- {{item.complemento}}  &nbsp;&nbsp;&nbsp;<span style="font-weight: bold;">{{item.tarifa}}</span>
            </mat-list-item>
        </span>
    </mat-nav-list>
    
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="cerrar('cerrar');" >Cancelar</button>  
</mat-dialog-actions>